/**
 * DEV-1819. Переводы галереи строк витрины и юнитов (эпик DEV-1075).
 *
 * Отдельным модулем, как propertyShowcase/propertyUnits: правки картинок не конфликтуют с
 * общим ru.ts.
 *
 * Терминология согласована с блоком витрины: «планировка» — чертёж квартиры,
 * «отделка» — варианты сдачи и меблировки.
 */

const ruImages = {
  title: 'Картинки',
  add: 'Загрузить',
  remove: 'Убрать картинку',
  empty: 'Пока пусто',
  uploading: 'Загружаем…',
  uploadError: 'Не удалось загрузить картинки',
  uploadPartial: 'Часть картинок загрузить не удалось',
  saveError: 'Картинки сохранить не удалось — сама запись прошла',
  types: {
    PROPERTY_IMAGE_TYPE_LAYOUT: 'Планировка',
    PROPERTY_IMAGE_TYPE_FINISHING: 'Варианты отделки',
  },
  badge: {
    inherited: 'Из юнитов',
    own: 'Свои',
  },
  resetToUnits: 'Показывать картинки юнитов',
  confirmReset:
    'Убрать свои картинки строки? На сайте вместо них появятся планировки юнитов этой группы.',
  reset: 'Свои картинки убраны — показываются картинки юнитов',
  applyToLayout: 'Применить ко всем юнитам с планировкой {code}',
  appliedToLayout: 'Картинки применены ещё к {count} юнитам',
}

const enImages = {
  title: 'Pictures',
  add: 'Upload',
  remove: 'Remove picture',
  empty: 'Nothing yet',
  uploading: 'Uploading…',
  uploadError: 'Could not upload the pictures',
  uploadPartial: 'Some pictures failed to upload',
  saveError: 'The pictures were not saved — the record itself was',
  types: {
    PROPERTY_IMAGE_TYPE_LAYOUT: 'Floor plan',
    PROPERTY_IMAGE_TYPE_FINISHING: 'Finishing options',
  },
  badge: {
    inherited: 'From units',
    own: 'Own',
  },
  resetToUnits: 'Show unit pictures',
  confirmReset:
    'Remove the pictures of this row? The site will show the floor plans of the units in this group instead.',
  reset: 'Own pictures removed — unit pictures are shown',
  applyToLayout: 'Apply to every unit with layout {code}',
  appliedToLayout: 'Pictures applied to {count} more units',
}

const vnImages = {
  title: 'Hình ảnh',
  add: 'Tải lên',
  remove: 'Xoá hình',
  empty: 'Chưa có hình',
  uploading: 'Đang tải…',
  uploadError: 'Không thể tải hình lên',
  uploadPartial: 'Một số hình tải lên không thành công',
  saveError: 'Không lưu được hình — bản ghi vẫn đã lưu',
  types: {
    PROPERTY_IMAGE_TYPE_LAYOUT: 'Mặt bằng',
    PROPERTY_IMAGE_TYPE_FINISHING: 'Phương án hoàn thiện',
  },
  badge: {
    inherited: 'Từ căn hộ',
    own: 'Riêng',
  },
  resetToUnits: 'Hiển thị hình của căn hộ',
  confirmReset:
    'Xoá hình riêng của dòng này? Website sẽ hiển thị mặt bằng của các căn hộ trong nhóm.',
  reset: 'Đã xoá hình riêng — hiển thị hình của căn hộ',
  applyToLayout: 'Áp dụng cho mọi căn hộ có mặt bằng {code}',
  appliedToLayout: 'Đã áp dụng hình cho {count} căn hộ khác',
}

export const showcaseGalleryMessages = {
  ru: { properties: { images: ruImages } },
  en: { properties: { images: enImages } },
  vn: { properties: { images: vnImages } },
}
